import ReviewsConstants from '../constants/Reviews.constants';

import ReviewSchema from 'Shared/utils/normalizeJSON/schemas/Review.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

import { FetchReviewsContext } from 'Shared/api/Reviews.api';

import { showNotificationError } from 'Shared/helpers';
import * as ReviewsAPI from '../api/Reviews.api';
import WpToastManager from 'Wpds/components/toast/WpToastManager';

export const fetchReviewSuccess = payload => ({
  type: ReviewsConstants.Actions.FETCH_SINGLE_REVIEW_SUCCESS,
  payload,
});

export const fetchReviewsSuccess = payload => ({
  type: ReviewsConstants.Actions.FETCH_REVIEWS_SUCCESS,
  payload,
});

export const createReviewSuccess = payload => ({
  type: ReviewsConstants.Actions.CREATE_REVIEW_SUCCESS,
  payload,
});

export const updateReviewSuccess = payload => ({
  type: ReviewsConstants.Actions.UPDATE_REVIEW_SUCCESS,
  payload,
});

export const receiverViewedReviewSuccess = payload => ({
  type: ReviewsConstants.Actions.RECEIVER_VIEWED_REVIEW_SUCCESS,
  payload,
});

export const fetchReview = ({ reviewSlug }) => dispatch => {
  return ReviewsAPI.fetchReview(reviewSlug)
    .then(response => {
      dispatch(fetchReviewSuccess(normalizer(ReviewSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
      return error.response;
    });
};

export const fetchReviews = ({
  context,
  reviewCycleSlug,
}: { context?: FetchReviewsContext; reviewCycleSlug?: string } = {}) => dispatch => {
  return ReviewsAPI.fetchReviews({ context, reviewCycleSlug })
    .then(response => {
      dispatch(fetchReviewsSuccess(normalizer(ReviewSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const createReview = data => dispatch => {
  return ReviewsAPI.createReview(data)
    .then(response => {
      WpToastManager.success('Review created');
      dispatch(createReviewSuccess(normalizer(ReviewSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const updateReview = ({ reviewSlug, data }) => dispatch => {
  return ReviewsAPI.updateReview(reviewSlug, data)
    .then(response => {
      dispatch(updateReviewSuccess(normalizer(ReviewSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const receiverViewedReview = ({ reviewSlug }) => dispatch => {
  return ReviewsAPI.receiverViewedReview(reviewSlug)
    .then(response => {
      dispatch(receiverViewedReviewSuccess(normalizer(ReviewSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};
